import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { PAYPAL_CLIENT_ID } from "@constant";
import CheckoutForm from "@paypalcheckout";

const Paypal = (props) => {
  const browserLanguage = Intl.DateTimeFormat()
    .resolvedOptions()
    .locale.replace("-", "_");
  // console.log(browserLanguage); // Example output: "en-US"

  const options = {
    clientId: PAYPAL_CLIENT_ID,
    locale: browserLanguage,

    // Add other options as needed
  };

  return (
    <PayPalScriptProvider options={options}>
      <CheckoutForm {...props} />
    </PayPalScriptProvider>
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Paypal);
